export default __webpack_public_path__ + "static/phone-benefits-3e58e8e9c45aee3ef33871786113dac7.png";